import { render } from "./ModelComponent.vue?vue&type=template&id=209e8bb6&scoped=true"
import script from "./ModelComponent.vue?vue&type=script&lang=js"
export * from "./ModelComponent.vue?vue&type=script&lang=js"

import "./ModelComponent.vue?vue&type=style&index=0&id=209e8bb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209e8bb6"]])

export default __exports__